import { comparisonData } from '@/mocks/categories';

export default function ComparisonTable() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-4">
            Compare Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Pandabuy Spreadsheet Category Comparison
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            See how our categories stack up by product count, browsing difficulty, and popularity among shoppers.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-200/70">
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 whitespace-nowrap">Category</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 whitespace-nowrap">Products</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 whitespace-nowrap">Difficulty</th>
                <th className="text-left px-5 py-3.5 font-semibold text-foreground-900 whitespace-nowrap">Popularity</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.type}
                  className={`border-t border-background-200/50 ${
                    idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  } hover:bg-background-100 transition-colors`}
                >
                  <td className="px-5 py-3 text-foreground-800 font-medium whitespace-nowrap">{row.type}</td>
                  <td className="px-5 py-3 text-foreground-700 whitespace-nowrap">{row.products}</td>
                  <td className="px-5 py-3 whitespace-nowrap">
                    <span
                      className={`inline-block px-2.5 py-0.5 text-xs font-medium rounded-full ${
                        row.difficulty === 'Easy'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {row.difficulty}
                    </span>
                  </td>
                  <td className="px-5 py-3 whitespace-nowrap">
                    <span
                      className={`inline-block px-2.5 py-0.5 text-xs font-medium rounded-full ${
                        row.popularity === 'Very High'
                          ? 'bg-primary-100 text-primary-700'
                          : row.popularity === 'High'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {row.popularity}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}